var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16.621,
    height: 16.621,
    viewBox: "0 0 16.621 16.621",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2 {\r\n        fill: #f5f5f5;\r\n      }\r\n\r\n      .cls-1 {\r\n        clip-rule: evenodd;\r\n      }\r\n\r\n      .cls-3 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n\r\n      .cls-4 {\r\n        clip-path: url(#clip-path-2);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    "data-name": "Path 391",
    className: "cls-1",
    d: "M1361.329,824.065a5.374,5.374,0,0,1-1.106,3.288l-.759-.659a4.344,4.344,0,0,0,0-5.258l.759-.66A5.38,5.38,0,0,1,1361.329,824.065Zm.407-4.6-.759.66a6.515,6.515,0,0,1,0,7.888l.759.66a7.619,7.619,0,0,0,0-9.208Zm1.514-1.316-.76.66a8.7,8.7,0,0,1,0,10.52l.76.661a9.805,9.805,0,0,0,0-11.84Zm-13.655,10.076a9.326,9.326,0,0,1,0-8.31h2.934l5.867-4.156v16.621l-5.867-4.155Zm2.934-3.117v-4.156h-2.389a9.184,9.184,0,0,0,0,6.232h2.686l4.592,3.253v-12.74l-3.911,2.771v3.6A1.009,1.009,0,0,1,1352.529,825.1Z",
    transform: "translate(-1348.618 -815.755)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_479",
    "data-name": "Rectangle 479",
    className: "cls-2",
    width: 112.732,
    height: 80.575
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SonidoON",
    transform: "translate(-1348.618 -815.755)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_890",
    "data-name": "Group 890",
    className: "cls-3",
    transform: "translate(1348.618 815.755)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_889",
    "data-name": "Group 889",
    transform: "translate(-32.157 -31.796)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_888",
    "data-name": "Group 888",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_478",
    "data-name": "Rectangle 478",
    className: "cls-2",
    width: 17.344,
    height: 17.343,
    transform: "translate(31.795 31.435)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolume);
export default __webpack_public_path__ + "static/media/volume.cde219d1fabd9a71affd2fc4cfaaecc2.svg";
export { ForwardRef as ReactComponent };